import PropTypes from 'prop-types';

// DOMRect is not supported in Edge Legacy, this is intended to be a stand-in
// until support for this browser is dropped
export default class Rectangle {
  constructor() {
    this.left = 0;
    this.right = 0;
    this.top = 0;
    this.bottom = 0;
    this.width = 0;
    this.height = 0;
  }
}
export const RectangleShape = PropTypes.shape({
  left: PropTypes.number.isRequired,
  right: PropTypes.number.isRequired,
  top: PropTypes.number.isRequired,
  bottom: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired
});